import React from 'react'
import PropTypes from 'prop-types'
import { deactivateZendeskIntegration } from 'actions'
import { connect } from 'react-redux'
import * as R from 'ramda'

import { connectApi } from 'libs/connectApi'
import generateUserActivityLog from 'libs/generateUserActivityLog'
import { ACTION_NAME } from 'hooks/useSaveUserActivityLog'

class DeActivateAuthentication extends React.Component {
  static propTypes = {
    surveyId: PropTypes.number.isRequired,
    deactivateZendeskIntegration: PropTypes.func.isRequired,
    createUserActivityLog: PropTypes.object,
  }

  /**
   *
   * @param {import('hooks/useSaveUserActivityLog').ACTION_NAME} action
   * @param {object} requestBody
   * @param {number} statusCode
   */
  saveUserActivityLog = (action, requestBody, statusCode) => {
    const data = generateUserActivityLog({
      action,
      target: 'zendesk_credential',
      statusCode,
      requestBody,
    })
    this.props.createUserActivityLog.callApi({ data })
  }

  onClickRevoke = async () => {
    const action = ACTION_NAME.revoke_zendesk_credential
    try {
      await this.props.deactivateZendeskIntegration(this.props.surveyId)
      this.saveUserActivityLog(action, {}, 200)
    } catch (error) {
      this.saveUserActivityLog(action, {}, 400)
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="ui segment">
          <div className="ui stackable grid">
            <div className="ten wide column middle aligned">
              <h4>
                <i className="ui icon fas fa-check green" /> Authenticated with Zendesk
              </h4>
            </div>
            <div className="six wide column right aligned">
              <a className="ui negative basic button" onClick={this.onClickRevoke}>
                Revoke access
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapDispatch = (dispatch, { surveyId }) => ({
  deactivateZendeskIntegration: () => dispatch(deactivateZendeskIntegration(surveyId)),
})

export default R.compose(
  connect(null, mapDispatch),
  connectApi({
    name: 'createUserActivityLog',
    url: `/user-activity-log/write/`,
    method: 'post',
    skip: true,
  })
)(DeActivateAuthentication)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Zendesk/DeActivateAuthentication.js